import { ClippingStudioGraphicCatalogItem } from "./clipping-studio-graphic-catalog";

export abstract class IClippingStudioGraphicsRepository {
  abstract getCatalogItems(): Promise<ClippingStudioGraphicCatalogItem[]>;
  abstract searchCatalogItems(query: string): Promise<ClippingStudioGraphicCatalogItem[]>;
}
